/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Button } from "ui/chakra/components/Button";

import { OutlineCartIcon } from "./OutlineCartIcon/OutlineCartIcon";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  addToCart: () => void;
  isDisabled: boolean;
};

export const AddToCartButtonV2: FcWithoutChildren<Props> = (props) => {
  const { addToCart, isDisabled } = props;

  return (
    <Button
      css={iconStyle}
      disabled={isDisabled}
      leftIcon={<OutlineCartIcon height={20} width={20} />}
      size="lg"
      onClick={addToCart}
    >
      {/* TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159 */}
      カート追加
    </Button>
  );
};

const iconStyle = css`
  & {
    svg {
      height: 20px;
      width: 20px;
    }
  }
`;
